export default "__VITE_ASSET__aef032d6__"